// src/pages/cadastro/CadastroComum.js — o cadastro do Starter e do Business (out/26).
//
// Do Claude Design "Cadastro.dc.html": o título com os três pontos (API
// Oficial, sem campos técnicos, ativação em minutos), o selo girando
// ("API OFICIAL DO WHATSAPP ✦ TECH PROVIDER META ✦") e a faixa do que deixa o
// cadastro seguro — Tech Provider e LGPD estão no contrato (cláusulas 4.2 e
// 5). A etapa 1 escolhe o plano; a 3 mostra o pedido; o resumo ao lado
// acompanha o plano escolhido. Com o PLUS fora da campanha, a escolha mostra
// só ele (sob medida, sem "Trocar para").
import TelaCadastro, { chaveRecurso, ICONE, NotaCobranca, Recurso, Svg } from './TelaCadastro';

const CONFIANCA = [
  { icone: ICONE.escudo, titulo: 'Parceira oficial Meta', sub: 'Credenciada como Tech Provider' },
  { icone: 'M4.5 19.5l1.2-3.6A8 8 0 1 1 8.4 18.6z M9 11.5h6 M9 14h4', titulo: 'API Oficial do WhatsApp', sub: 'Conectado pelo fluxo da Meta' },
  { icone: 'M3.5 6.5h17v11h-17z M3.5 10h17 M7 14.5h4', titulo: 'Pagamento via Stripe', sub: 'A Cetto não armazena seu cartão' },
  { icone: 'M6 11h12v9H6z M8.5 11V8a3.5 3.5 0 0 1 7 0v3 M12 14.5v2', titulo: 'Dados protegidos pela LGPD', sub: 'Lei nº 13.709/2018, em contrato' },
];

function Topo() {
  return (
    <section className="cad-hero" aria-labelledby="cad-titulo">
      <div className="cad-hero-brilho" aria-hidden="true" />
      <div className="cad-hero-in">
        <div className="cad-hero-texto">
          <p className="cad-sobretitulo">Cetto System — Cadastro</p>
          <h1 id="cad-titulo">Sua operação blindada começa aqui</h1>
          <ul className="cad-hero-pontos">
            <li>API Oficial Meta</li>
            <li>Sem campos técnicos</li>
            <li>Ativação em minutos</li>
          </ul>
        </div>
        <div className="cad-selo-lugar">
          <div className="cad-selo-oficial" role="img" aria-label="Selo: API Oficial do WhatsApp, a Cetto é Tech Provider da Meta">
            <div className="cad-selo-aro" aria-hidden="true">
              <svg viewBox="0 0 160 160">
                <defs><path id="cad-selo-arco" d="M80,80 m-63,0 a63,63 0 1,1 126,0 a63,63 0 1,1 -126,0" /></defs>
                <circle cx="80" cy="80" r="78" />
                <text><textPath href="#cad-selo-arco" textLength="392" lengthAdjust="spacing">API OFICIAL DO WHATSAPP ✦ TECH PROVIDER META ✦</textPath></text>
              </svg>
            </div>
            <div className="cad-selo-centro" aria-hidden="true">
              <Svg d={ICONE.escudo} tamanho={24} />
              <span>OFICIAL</span>
            </div>
          </div>
        </div>
      </div>
      <div className="cad-confianca">
        <ul aria-label="Por que o cadastro é seguro">
          {CONFIANCA.map((c) => (
            <li key={c.titulo}>
              <span className="cad-confianca-icone"><Svg d={c.icone} tamanho={22} /></span>
              <span><b>{c.titulo}</b><span className="cad-confianca-sub">{c.sub}</span></span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

// Rádio de verdade (input escondido dentro do cartão): as setas do teclado
// trocam o plano e o leitor de tela anuncia "1 de 2".
function EscolhaPlano({ planos, chave, escolher, testeDisponivel }) {
  return (
    <div className="cad-planos">
      <p className="cad-planos-rot" id="cad-plano-rot">Plano escolhido</p>
      <div className="cad-planos-grade" role="radiogroup" aria-labelledby="cad-plano-rot">
        {Object.entries(planos).map(([k, p]) => {
          const sel = k === chave;
          return (
            <label key={k} className={`cad-plano${sel ? ' cad-plano-sel' : ''}`} style={{ '--cad-cor-plano': p.color }}>
              <input type="radio" name="cad-plano" className="cad-oculto" value={k} checked={sel} onChange={() => escolher(k)} />
              <span className="cad-plano-topo">
                <span className="cad-plano-radio" aria-hidden="true" />
                {p.popular && <span className="cad-plano-popular">Mais popular</span>}
              </span>
              <span className="cad-plano-nome">{p.name}</span>
              <span className="cad-plano-preco"><b>{p.price}</b>{p.priceUnit}</span>
              <span className="cad-recursos">
                {p.features.map((f) => <Recurso key={chaveRecurso(f)} recurso={f} tamanho={16} como="span" />)}
              </span>
            </label>
          );
        })}
      </div>
      {testeDisponivel && (
        <p className="cad-planos-nota">
          <Svg d={ICONE.relogio} tamanho={18} traco={1.75} />
          <span><b>Só após 7 dias</b>, a Cetto cobrará automaticamente pelo valor do plano que selecionar acima. Cancele a qualquer momento.</span>
        </p>
      )}
    </div>
  );
}

// Etapa 3. "Trocar para" é o mesmo do cadastro antigo: quem retoma o
// cadastro (etapa 1 fechada) ainda pode mudar de Starter pra Business antes
// do pagamento. Plano sob medida não troca.
function ResumoPedido({ plano, alternativa, trocar }) {
  return (
    <div className="cad-pedido">
      <p className="cad-pedido-rot">Resumo do pedido</p>
      <div className="cad-pedido-linha">
        <span>
          Plano {plano.name}
          {alternativa && <button type="button" className="cad-link cad-pedido-trocar" onClick={trocar}>Trocar para {alternativa.name}</button>}
        </span>
        <span>{plano.price}{plano.priceUnit}</span>
      </div>
      <div className="cad-pedido-total">
        <span>Total mensal</span>
        <span>{plano.price}</span>
      </div>
    </div>
  );
}

function SeuPlano({ plano, testeDisponivel }) {
  return (
    <aside className="cad-resumo" aria-label="Resumo do plano" style={{ '--cad-cor-plano': plano.color }}>
      <div className="cad-resumo-corpo">
        <p className="cad-seu-plano">Seu plano</p>
        <p className="cad-resumo-nome">{plano.name}</p>
        <p className="cad-resumo-valor"><b>{plano.price}</b>{plano.priceUnit}</p>
        <ul className="cad-recursos">
          {plano.features.map((f) => <Recurso key={chaveRecurso(f)} recurso={f} />)}
        </ul>
        <NotaCobranca testeDisponivel={testeDisponivel} />
      </div>
      <div className="cad-resumo-selos">
        <p><Svg d={ICONE.escudo} tamanho={18} traco={1.75} />Parceira oficial Meta · Tech Provider</p>
        <p><Svg d={ICONE.cadeado} tamanho={18} traco={1.75} />Pagamento via Stripe · LGPD</p>
      </div>
    </aside>
  );
}

export default function CadastroComum({ planos, chavePlano, escolherPlano, alternativa, trocarPlano, ...props }) {
  const plano = planos[chavePlano];
  return (
    <TelaCadastro
      {...props}
      classe="cad-comum"
      tituloAba="Cadastro | Cetto System"
      rotuloSecao="Formulário de cadastro"
      nivelEtapa="h2"
      plano={plano}
      topo={<Topo />}
      escolhaPlano={<EscolhaPlano planos={planos} chave={chavePlano} escolher={escolherPlano} testeDisponivel={props.testeDisponivel} />}
      resumoPedido={<ResumoPedido plano={plano} alternativa={alternativa} trocar={trocarPlano} />}
      caixaMeta
      notaSeguranca
      resumo={<SeuPlano plano={plano} testeDisponivel={props.testeDisponivel} />}
    />
  );
}
